export default {
  back: "Back"
};
